// @flow
import styled from '@emotion/styled';
import { color, SPACING } from '@tablekit/theme';
import { Z_INDICES } from 'utils/theme';

const iconWidth = 20;
const barWidth = 2;
const barSpacing = 4;

export const Positioner = styled.button`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  cursor: pointer;
  background: none;
  border: none;
  padding: ${SPACING.L4};
  position: fixed;
  top: ${SPACING.L1};
  right: ${SPACING.L1};
  width: ${iconWidth + parseInt(SPACING.L4, 10) * 2}px;
  height: ${barWidth * 3 + barSpacing * 2 + parseInt(SPACING.L4, 10) * 2}px;

  outline: none;
  z-index: ${Z_INDICES.MOBILE_NAV + 1};
`;

const IconBox = styled.span`
  width: ${iconWidth}px;
  height: ${barWidth * 3 + barSpacing * 2}px;
  display: inline-block;
  position: relative;
`;

const IconInner = styled.span`
  display: block;
  top: 50%;
  margin-top: ${barWidth / -2}px;
  transition-duration: 0.075s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);

  &,
  &::before,
  &::after {
    width: ${iconWidth}px;
    height: ${barWidth}px;
    background-color: currentColor;
    border-radius: 4px;
    position: absolute;
    transition-property: transform, background-color;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }

  &::before,
  &::after {
    content: '';
    display: block;
  }

  &::before {
    top: ${(barSpacing + barWidth) * -1}px;
  }

  &::after {
    bottom: ${(barSpacing + barWidth) * -1}px;
  }

  &::before {
    transition: top 0.075s 0.12s ease, opacity 0.075s ease,
      background-color 0.15s ease;
  }

  &::after {
    transition: bottom 0.075s 0.12s ease,
      transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19),
      background-color 0.15s ease;
  }

  color: currentColor;
  &.is-open {
    color: ${color('text')};
    transform: rotate(45deg);
    transition-delay: 0.12s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);

    &::before {
      top: 0;
      opacity: 0;
      transition: top 0.075s ease, opacity 0.075s 0.12s ease;
    }

    &::after {
      bottom: 0;
      transform: rotate(-90deg);
      transition: bottom 0.075s ease,
        transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }
`;

const MobileNavToggle = ({
  isOpen,
  isVisible,
  toggleOpen
}: {
  isOpen: boolean,
  isVisible: boolean,
  toggleOpen: () => void
}) => (
  <Positioner
    ref={(ref) => {
      if (!ref) return;
      // see https://stackoverflow.com/questions/55461449/unable-to-preventdefault-inside-passive-event-listener-due-to-target-being-treat
      // weird chrome thing
      ref.addEventListener(
        'touchstart',
        (event: SyntheticEvent<HTMLButtonElement>) => {
          event.stopPropagation();
        },
        { passive: false }
      );
      ref.addEventListener(
        'mousedown',
        (event: SyntheticEvent<HTMLButtonElement>) => {
          event.stopPropagation();
        },
        { passive: false }
      );
    }}
    isVisible={isVisible}
    onClick={toggleOpen}
  >
    <IconBox>
      <IconInner className={isOpen ? 'is-open' : ''} />
    </IconBox>
  </Positioner>
);

export default MobileNavToggle;
